import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const GOLD = "#C9A84C";
const NAVY = "#0A1628";

/* Slim marketing announcement bar. Rendered inside PublicHeader, so it never appears
   inside the logged-in application shell. */
export const AnnounceBar = () => (
  <div className="h-9 flex items-center overflow-hidden" style={{ background: GOLD }} data-testid="announcement-bar">
    <div className="max-w-[1280px] w-full mx-auto px-4 sm:px-6 flex items-center gap-3">
      <p className="flex-1 min-w-0 text-center text-[11.5px] sm:text-[13px] font-semibold leading-none truncate"
         style={{ color: NAVY, letterSpacing: "0.01em" }} data-testid="announcement-bar-text">
        India's Industrial EPC Execution and O&amp;M Platform — Trusted by EPC Contractors, Site Engineers, and
        Project Managers across India
      </p>
      <Link to="/features"
            className="hidden md:inline-flex shrink-0 items-center gap-1 h-6 px-3 rounded-full text-[11.5px] font-semibold text-white transition-transform duration-150 hover:-translate-y-px"
            style={{ background: NAVY }} data-testid="announcement-bar-cta">
        See All Features <ArrowRight className="w-3 h-3" />
      </Link>
    </div>
  </div>
);
